import React, { useState, useEffect } from 'react';

function ResultsView({ productName, yeild, cost, costPerUnit, totalUnit, breakdown, alreadySaved, onSave, onNewRecipe }) {
  const [saved, setSaved] = useState(alreadySaved || false);

  useEffect(() => {
    setSaved(alreadySaved || false);
  }, [alreadySaved, productName]);

  function handleSave() {
    if (saved) return;
    const recipe = {
      id: Date.now(),
      name: productName || 'Unnamed Recipe',
      yeild,
      cost,
      totalUnit,
      costPerUnit,
      breakdown,
      savedAt: new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }),
    };
    onSave(recipe);
    setSaved(true);
  }

  return (
    <main className="main-container">
      <div className="page-title">
        <h1>{productName || 'Recipe'}</h1>
        <p>Cost breakdown</p>
      </div>

      <div className="summary-grid">
        <div className="summary-card">
          <div className="summary-value">{yeild}g</div>
          <div className="summary-label">Total Yield</div>
        </div>
        <div className="summary-card">
          <div className="summary-value">&#8377;{cost}</div>
          <div className="summary-label">Total Cost</div>
        </div>
        <div className="summary-card">
          <div className="summary-value">{totalUnit}</div>
          <div className="summary-label">Units</div>
        </div>
        <div className="summary-card highlight">
          <div className="summary-value">&#8377;{costPerUnit}</div>
          <div className="summary-label">Cost per Unit</div>
        </div>
      </div>

      <div className="card">
        <h2 className="card-title">Ingredient Breakdown</h2>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Ingredient</th>
                <th>Weight</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              {breakdown.map((item, i) => (
                <tr key={i}>
                  <td>{item.name}</td>
                  <td>{item.weight}g</td>
                  <td>&#8377;{item.cost}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{yeild}g</strong></td>
                <td><strong>&#8377;{cost}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div className="results-actions">
        <button
          className={`btn ${saved ? 'btn-saved' : 'btn-save'}`}
          onClick={handleSave}
          disabled={saved}
        >
          {saved ? '\u2713 Saved' : 'Save Recipe'}
        </button>
        <button className="btn btn-primary" onClick={onNewRecipe}>
          + New Recipe
        </button>
      </div>
    </main>
  );
}

export default ResultsView;
